var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tippy-component",
    {
      ref: "tippy-tooltip",
      staticClass: "z-tooltip",
      class: _vm.classObject,
      attrs: {
        interactive: _vm.setInteractive(),
        theme: _vm.theme,
        arrow: _vm.arrow,
        trigger: _vm.trigger,
        placement: _vm.placement,
      },
      on: { show: _vm.stateTooltip, hide: _vm.stateTooltip },
      scopedSlots: _vm._u(
        [
          {
            key: "trigger",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "z-tooltip__trigger" },
                  [
                    _vm._t("default"),
                    _vm._v(" "),
                    _c("z-icon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.iconHidden,
                          expression: "!iconHidden",
                        },
                      ],
                      staticClass: "z-tooltip__icon",
                      attrs: {
                        width: "16",
                        height: "16",
                        name: "information-stroke",
                      },
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [_vm._v(" "), _c("span", { domProps: { innerHTML: _vm._s(_vm.content) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }